import { render, staticRenderFns } from "./ListSorter.vue?vue&type=template&id=82d708a2&scoped=true&"
import script from "./ListSorter.vue?vue&type=script&lang=ts&"
export * from "./ListSorter.vue?vue&type=script&lang=ts&"
import style0 from "./ListSorter.vue?vue&type=style&index=0&id=82d708a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d708a2",
  null
  
)

export default component.exports